// Selection Choice
export const gearSelectionChoiceArray = ['All', 'Validated', 'PendingValidation'];

// Validation Choice
export const gearValidationChoiceArray = ['Validated', 'PendingValidation'];
